export default function (entry) {
	return '';
}
